// extracted by mini-css-extract-plugin
export default {"Details":"Details_Details__EaeyW","Left":"Details_Left__k-Qkf","Right":"Details_Right__puhq1","Main":"Details_Main__+Kbo+","About":"Details_About__21L22"};